import React from "react";

export default function LogViewer ({ message }: { message: string | object }) {
  return (
    <div className="text-sm p-2">
      <pre>{typeof message === "object" ? JSON.stringify(message, null, 2) : message}</pre>
    </div>
  );
};